import { render } from "./praReceiptDialog.vue?vue&type=template&id=2c766138&scoped=true"
import script from "./praReceiptDialog.vue?vue&type=script&lang=js"
export * from "./praReceiptDialog.vue?vue&type=script&lang=js"

import "./praReceiptDialog.vue?vue&type=style&index=0&id=2c766138&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c766138"]])

export default __exports__